module.exports = __webpack_public_path__ + "static/bg-home2-021c6565631463ea1c705af71c00ba96.jpeg";